module.exports = __webpack_public_path__ + "img/welcome.164ddad4.png";